<template>
  <div class="page-wrapper-top">
    <div class="page-header">
      <!-- Usuário -->
      <div class="page-header-top">
        <div class="container-fluid">
          <!-- Logo-->
          <div class="page-top-content">
            <div class="page-logo">
              <router-link to="/dashboard">
                <img alt="logo" class="img-responsive new-logo" src="../../../../assets/img/logo-marq.png"/>
              </router-link>
            </div>
            <!-- SEARCH INPUT -->
            <div class="col-md-6 support-search hidden-xs">
              <div class="support-search-content">
                <input v-if="category == 1" v-model="dataSearch.id" autocomplete="no" maxlength="100"
                       placeholder="ID da empresa" type="text"/>
                <input v-if="category == 2" v-model="dataSearch.name" autocomplete="no" maxlength="100"
                       placeholder="Nome da empresa" type="text"/>
                <input v-if="category == 3" v-model="dataSearch.cnpj" autocomplete="no" v-mask="['##############']"
                       maxlength="33" placeholder="CNPJ sem pontos" type="text"/>
                <input v-if="category == 4" v-model="dataSearchUser.userId" autocomplete="no" maxlength="100"
                       placeholder="ID exato do usuario" type="text"/>
                <input v-if="category == 5" v-model="dataSearchUser.nomeF" autocomplete="no" maxlength="100"
                       placeholder="Nome do funcionário" type="text"/>
                <input v-if="category == 6" v-model="dataSearchUser.cpf" autocomplete="no" v-mask="['###########']"
                       maxlength="100" placeholder="CPF sem pontos" type="text"/>
                <input v-if="category == 7" v-model="dataSearchUser.email" autocomplete="no" maxlength="100"
                       placeholder="E-mail do funcionário" type="text"/>
                <input v-if="category == 8" v-model="dataSearch.link" autocomplete="no"
                       placeholder="Link da fatura/boleto" type="text"/>

                <div class="support-search-sub-content">
                  <div class="dropdown">
                    <select v-model="category">
                      <option value="1">ID da empresa</option>
                      <option value="2">Nome da empresa</option>
                      <option value="3">CNPJ da empresa</option>
                      <option value="4">ID do funcionário</option>
                      <option value="5">Nome do funcionário</option>
                      <option value="6">CPF do funcionário</option>
                      <option value="7">E-mail do funcionário</option>
                      <option value="8">Link da Fatura/Boleto</option>
                    </select>
                    <ion-icon name="chevron-down-outline"></ion-icon>
                  </div>
                  <a v-on:click="getSearch()">
                    <ion-icon name="search-outline"></ion-icon>
                  </a>
                </div>
              </div>
            </div>

            <!-- BEGIN TOP NAVIGATION MENU -->
            <div class="top-menu">
              <ul class="nav navbar-nav pull-right">
                <!-- Linha divisoria -->
                <li class="droddown dropdown-separator">
                  <span class="separator"></span>
                </li>

                <!-- Drop down usuario -->
                <li class="dropdown dropdown-user dropdown-dark">
                  <a class="dropdown-toggle" data-close-others="true" data-hover="dropdown" data-toggle="dropdown">
                    <img v-if="userInfo.photo" alt="user" class="img-circle" v-bind:src="userInfo.photo"/>
                    <img v-else alt="company" class="img-circle" src="../../../../assets/img/user-default.png"/>
                    <span class="username username-hide-mobile fix-title" v-bind:title="userInfo.name">
                      {{ userInfo.name }}
                    </span>
                    <ion-icon name="chevron-down-outline"/>
                  </a>
                  <ul class="dropdown-menu dropdown-menu-default">
                    <li id="logoutBtn" class="logout-btn">
                      <a v-on:click="logoutMenu()">
                        <ion-icon name="log-out-outline"/>
                        Sair
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Menu de páginas -->
      <div class="page-header-menu">
        <div class="container-fluid container-fluid-header">
          <!-- Páginas -->
          <div class="hor-menu">
            <ul class="nav navbar-nav">
              <!-- Dashboard -->
              <li aria-haspopup="true">
                <router-link to="/dashboard">Dashboard</router-link>
              </li>

              <!-- Onboardings -->
              <li aria-haspopup="true" class="menu-dropdown classic-menu-dropdown">
                <a> Onboardings
                  <ion-icon name="chevron-down-outline"/>
                </a>
                <ul class="dropdown-menu pull-left">
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/lista-de-onboarding">Lista de Onboarding</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/lista-avaliacao-de-onboarding">Avaliação de Onboarding
                    </router-link>
                  </li>
                </ul>
              </li>

              <!-- Empresas -->
              <li aria-haspopup="true" class="menu-dropdown classic-menu-dropdown">
                <a> Empresa
                  <ion-icon name="chevron-down-outline"/>
                </a>
                <ul class="dropdown-menu pull-left">
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/lista-de-empresas">Lista de Empresas</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/empresa-marqtab">MarQTabs</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/detalhes-cancelamentos">Cancelamentos</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/cancelamentos-old">Cancelamentos (Antigo)</router-link>
                  </li>
                  <!--                  <li aria-haspopup="true">-->
                  <!--                    <router-link class="nav-link" to="/lista-de-churns">Churns</router-link>-->
                  <!--                  </li>-->
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/lista-de-churns-old">Churns</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/cadastrar-empresa/TTTT">Cadastrar Empresa</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/followup">FollowUp</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/relatorio-de-vendas">Vendas
                    </router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/lista-de-pins">Pins
                    </router-link>
                  </li>
                </ul>
              </li>

              <!-- Usuários -->
              <li aria-haspopup="true" class="menu-dropdown classic-menu-dropdown">
                <a> Usuário
                  <ion-icon name="chevron-down-outline"/>
                </a>
                <ul class="dropdown-menu pull-left">
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/usuarios-ativos">Usuários</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/detalhes-dia-usuario">Detalhes do dia por usuário</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/ultimos-acessos">Últimos Acessos</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/aparelhos">Aparelhos</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/usuarios-login">Usuários e Logins</router-link>
                  </li>
                </ul>
              </li>

              <!-- Código -->
              <li aria-haspopup="true" class="menu-dropdown classic-menu-dropdown">
                <a> Código e Promoção
                  <ion-icon name="chevron-down-outline"/>
                </a>
                <ul class="dropdown-menu pull-left">
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/codigos-gerado">Lista de Códigos</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/cadastro-de-codigo">Cadastro de Código</router-link>
                  </li>
                </ul>
              </li>

              <!-- Pagamento -->
              <li v-if="showMenu" aria-haspopup="true" class="menu-dropdown classic-menu-dropdown">
                <a> Pagamentos
                  <ion-icon name="chevron-down-outline"/>
                </a>
                <ul class="dropdown-menu pull-left">
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/lista-pagamentos">Pagamentos</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/excedentes">Excedentes</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/lista-de-renovacao">Renovações</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/lista-de-upsell">Upsell</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/pendentes-expirados">Pendentes e Expirados</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/lista-de-assinaturas">Lista de assinaturas</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/historico-de-faturas">Histórico de faturas</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/notas-fiscais">Notas Fiscais</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/nova-venda">Nova venda</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/healthcheck-pagamentos">Healthcheck Pag./NF</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/migracao-asaas">Migração ASAAS</router-link>
                  </li>
                </ul>
              </li>

              <!-- NPS -->
              <li aria-haspopup="true" class="menu-dropdown classic-menu-dropdown">
                <a> NPS
                  <ion-icon name="chevron-down-outline"/>
                </a>
                <ul class="dropdown-menu pull-left">
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/novo-nps">NOVO NPS</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/analise-de-nps">Analise NPS (Descontinuado)</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/lista-de-nps">Lista de NPS (Descontinuado)</router-link>
                  </li>
                </ul>
              </li>

              <!-- Log de Ponto -->
              <li aria-haspopup="true" class="menu-dropdown classic-menu-dropdown">
                <a> Logs
                  <ion-icon name="chevron-down-outline"/>
                </a>
                <ul class="dropdown-menu pull-left">
                  <!--                  <li aria-haspopup="true">-->
                  <!--                    <router-link to="/log-de-ponto" class="nav-link">Log de Ponto</router-link>-->
                  <!--                  </li>-->
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/log-armazenados">Logs (App , MarQTab e MarQWeb)</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/log-de-notas-fiscais">Log de notas fiscal</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/log-de-saldo-por-funcionario">Log de saldo por funcionario
                    </router-link>
                  </li>
                  <!-- FB8c - histórico de mudanças em tags -->
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/historico-de-tags">Histórico de Tags</router-link>
                  </li>
                </ul>
              </li>

              <!-- Relatórios -->
              <li aria-haspopup="true" class="menu-dropdown classic-menu-dropdown">
                <a> Relatórios
                  <ion-icon name="chevron-down-outline"/>
                </a>
                <ul class="dropdown-menu pull-left">
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/relatorio-csat">Relatório CSAT</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/relatorio-ces">Relatório CES</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/problemas-de-upd">Problemas de UPD</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/relatorio-de-melhoria">Melhorias</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/relatorio-de-bugs">Bugs</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/relatorio-completo">MarQReportao</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/funcionalidades-extras">Funcionalidades extras</router-link>
                  </li>
                </ul>
              </li>

              <!-- Avisos e Campanhas -->
              <li aria-haspopup="true" class="menu-dropdown classic-menu-dropdown">
                <a> Avisos e Campanhas
                  <ion-icon name="chevron-down-outline"/>
                </a>
                <ul class="dropdown-menu pull-left">
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/avisos-e-campanhas">Campanhas</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/avisos-e-campanhas/novo">Novo aviso</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/avisos-e-campanhas/liberacoes">Liberação de funcionalidade</router-link>
                  </li>
                </ul>
              </li>

              <!-- Benefícios -->
              <li aria-haspopup="true" class="menu-dropdown classic-menu-dropdown">
                <a> Benefícios
                  <ion-icon name="chevron-down-outline"/>
                </a>
                <ul class="dropdown-menu pull-left">
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/pedido-beneficios-pix">Pedido via PIX</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/beneficios-dock">Dock</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/beneficios-dashboard">Dashboard benefícios</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/beneficios-pedidos">Pedidos de Benefícios</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/beneficios-kyc">KYC</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/solicitacao-cartao">Solicitações de Cartões</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/extrato-movimentacao-pma">Extrato de movimentação da PMA
                    </router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/resumo-empresa">Resumo da empresa
                    </router-link>
                  </li>
                </ul>
              </li>

              <!-- Suporte -->
              <li aria-haspopup="true" class="menu-dropdown classic-menu-dropdown">
                <a> Suporte
                  <ion-icon name="chevron-down-outline"/>
                </a>
                <ul class="dropdown-menu pull-left">
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/funil">Funil</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/tickets">Tickets</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/ferramentas">Ferramentas</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/reconhecimento-facial">Novo Reconhecimento Facial</router-link>
                  </li>
                  <li aria-haspopup="true">
                    <router-link class="nav-link" to="/reconhecimento-facial-poc">Telemetria Rec. Facial (POC)</router-link>
                  </li>
                </ul>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {GET_CONTEXT, SEARCH_BY_INVOICE, SEARCH_SUPPORT} from "../../../../urlConfig";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../requestConfig";
import {UTIL} from "../../../../utils";
import {ALERT_SERVICE} from "../../../../msgAlertService";

export default {
  name: "top-menu",
  data() {
    return {
      showMenu: false,
      loading: false,
      userInfo: "",
      idSupport: "",
      category: "1",
      dataSearch: {
        name: "",
        cnpj: "",
        link: ""
      },
      dataSearchUser: {
        nomeF: "",
        cpf: "",
        email: ""
      }
    };
  },
  methods: {
    getSearch() {
      this.loading = true;

      if (this.category === "8") {
        let regex = /^(http|https|Http|Https|rtsp|Rtsp):\/\//i;
        let isValidLink = regex.test(this.dataSearch.link);
        if (isValidLink) {
          this.searchByInvoice();
          return;
        } else {
          swal("Erro!", "Preencha um link válido.", "error");
        }
      }

      let urlFilter = "";
      let values = [
        this.dataSearch.name,
        this.dataSearch.cnpj,
        this.dataSearchUser.cpf,
        this.dataSearchUser.email,
        this.dataSearchUser.nomeF
      ];

      if (this.category === "2" || this.category === "3") {
        urlFilter = this.category === "2" ? values[0] : values[1];
        this.$router.push({
          path: `/lista-de-empresas/${urlFilter}/${this.category}`
        });
      }

      if (
        this.category === "5" ||
        this.category === "6" ||
        this.category === "7"
      ) {
        urlFilter =
          this.category === "5" ?
            values[4] :
            this.category === "6" ?
              values[2] :
              values[3];
        this.$router.push({
          path: `/usuarios-ativos/${urlFilter}/${this.category}`
        });
      }

      if (this.dataSearch.id || this.dataSearchUser.userId) {
        let url = GET_CONTEXT;

        if (this.dataSearchUser.userId)
          url += "?elementId=" + this.dataSearchUser.userId;

        if (this.dataSearch.id) url += "?elementId=" + this.dataSearch.id;

        if (this.category) url += "&elementType=" + this.category;

        REQUEST_SERVICE.requestContext("GET", url)
          .then(response => {
            UTIL_SERVICE.console("RESULT GET_CONTEXT:", response.data);
            this.loading = false;
            this.context = response.data;

            if (response.data !== "") {
              if (this.category === "4") {
                this.$router.push({
                  path: `/usuario/${this.dataSearchUser.userId}/${this.context}`
                });
              }

              if (this.category === "1") {
                this.$router.push({
                  path: `/detalhes-da-empresa/${this.dataSearch.id}/${
                    this.context
                  }`
                });
              }
            } else {
              ALERT_SERVICE.searchError();
            }
          })
          .catch(reason => {
            this.loading = false;
            ALERT_SERVICE.msgError("Nenhum resultado encontrado");
          });
      }
    },
    searchByInvoice() {
      let obj = {bankSlipUri: this.dataSearch.link};
      REQUEST_SERVICE.post(SEARCH_BY_INVOICE, obj).then(response => {
        this.$router.push({
          path: "/detalhes-da-empresa/" + response.data.companyId + "/" + response.data.contentSetting
        })
      }).catch(reason => {
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      })
    },
    searchSupport() {
      REQUEST_SERVICE.get(SEARCH_SUPPORT)
        .then(response => {
          UTIL_SERVICE.console("RESULT SEARCH_SUPPORT:", response.data);

          this.$router.push({
            path: "/detalhes-da-empresa/" +
              response.data.id +
              "/" +
              response.data.contentSetting
          });
        })
        .catch(reason => {
          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
    },
    logoutMenu() {
      REQUEST_SERVICE.logout()
        .then(response => {
          this.$router.push({
            path: "/login"
          });
        })
        .catch(reason => {
          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
    }
  },
  beforeMount() {
    this.userInfo = JSON.parse(
      window.localStorage.getItem("mamUserMasterInfo")
    );

    this.$route.params.userInfo = this.userInfo
  },
  mounted() {
    this.showMenu = UTIL.checkP(this.userInfo.id);
  }
};
</script>

<style lang="scss" scoped>

.top-menu {
  .dropdown-toggle {
    display: flex;
    align-items: center;

    .username {
      margin: 0 !important;
    }

    ion-icon {
      color: #8EA3B6;

      &:hover {
        color: #23527C;
      }
    }
  }

  .logout-btn {
    a {
      display: flex;
      align-items: center;

      ion-icon {
        margin-right: 4px;
      }
    }
  }
}

.classic-menu-dropdown {
  a {
    display: flex;
    align-items: center;

    ion-icon {
      margin-left: 4px;
    }
  }
}

.container-fluid-header {
  display: flex;
  justify-content: center;
  padding-right: 15px;
  padding-left: 15px;

  ul {
    li {
      a {
        padding: 15px 10px !important;
      }
    }
  }
}

.page-wrapper-top {
  .page-header {
    height: auto;

    .page-header-top {
      height: auto;

      .page-top-content {
        display: flex;
        justify-content: space-between;
        padding: 20px 0;
        height: 10rem;
        max-width: 98%;
        margin: auto;

        .page-logo {
          a {
            .new-logo {
              max-width: 85%;
            }
          }
        }

        .support-search {
          .support-search-content {
            width: 80%;
            margin: 11.5px auto 0 auto;
            position: relative;

            input {
              width: 100%;
              background: #EEF2F7;
              border-radius: 4px !important;
              padding: 6px 12px;
              border: 1px solid #EEF2F7;
              transition: .2s;
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);

              &::placeholder {
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
              }

              &:hover {
                transition: .2s;
                border: 1px solid #CACACA;
              }

              &:focus-visible {
                outline: none;
                transition: .2s;
                border: 1px solid #CACACA;

                &::placeholder {
                  transition: .1s;
                  color: #EEF2F7;
                }
              }

              //&:-webkit-autofill,
              //&:-webkit-autofill:hover,
              //&:-webkit-autofill:focus,
              //&:-webkit-autofill:active {
              //  -webkit-box-shadow      : 0 0 0 72px #EEF2F7 inset !important;
              //  -webkit-text-fill-color : #EEF2F7 !important;
              //}
            }

            .support-search-sub-content {
              display: flex;
              position: absolute;
              top: 0;
              right: 0;

              .dropdown {
                margin-right: 8px;

                select {
                  border-left: 1px solid #CACACA;
                  border-top: 1px solid transparent;
                  border-right: 1px solid transparent;
                  border-bottom: 1px solid transparent;
                  border-bottom-right-radius: 4px !important;
                  border-top-right-radius: 4px !important;
                  width: 120%;
                  margin-top: 2.5px;
                  margin-right: 20px;
                  background: #EEF2F7;
                  padding: 4px 8px;
                  transition: .2s;
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                  cursor: pointer;
                  -webkit-appearance: none;
                  -moz-appearance: none;
                  appearance: none;

                  &::placeholder {
                    font-size: 16px;
                    font-weight: 400;
                    color: var(--dark-gray);
                  }

                  &:focus-visible {
                    outline: none;
                  }
                }

                ion-icon {
                  position: absolute;
                  right: 0;
                  top: 8px;
                  color: var(--dark-gray);
                  font-size: 20px;
                  pointer-events: none;
                }
              }

              a {
                height: 32px;
                margin-top: 2px;
                border-left: 1px solid #CACACA;

                z-index: 1000;
                background: transparent;
                padding: 0 12px;
                color: var(--dark-gray);
                text-decoration: none;
                pointer-events: visible;

                &:hover {
                  color: var(--dark-black);
                }

                ion-icon {
                  font-size: 20px;
                  height: 100%;
                  width: 21px;
                }
              }
            }
          }
        }

        .top-menu {
          margin: 0;

          .pull-right {
            margin-top: 6px;
          }
        }

        @media only screen and(max-width: 991px) {
          .page-logo {
            width: 25%;
          }
          .support-search {
            width: 50%;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/default/topMenu.vue